import { useForm } from '@/components/forms';
import { useAttributes } from '@/hooks/useAttributes';
import { useDropdown } from '@/hooks/useDropdown';
import { z } from 'zod';
import { useCurrentCharges } from './useChargesList';

const assignChargesFormSchema = z.object({
  chargeType: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  userType: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  currentCommissionCharge: z.string(),
  newCommissionCategory: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
});

export const useAssignCharge = () => {
  const form = useForm({ schema: assignChargesFormSchema, mode: 'onBlur' });

  const { data: chargeType = [] } = useAttributes('chargeUserType') || {};

  const selectedUserType = form.watch('chargeType');
  const { currentCharges } = useCurrentCharges(!!selectedUserType, { affiliateId: selectedUserType });

  const { data: chargeCategory = [] } = useDropdown('ChargeCategory');
  const { data: userType = [] } = useDropdown('affiliateList');
  const userTypeRefined = userType.filter((val) => val.label !== '');

  return {
    form,
    chargeType,
    chargeCategory,
    userTypeRefined,
    currentCharges,
  };
};
